<template>
  <div>
    <img class="img" src="/assets/image/trumpet_stop.png" alt="音頻" @click="playVoice">
  </div>
</template>

<script>
export default {
  name: "TestTrumpetStop",
  methods: {
    playVoice: function () {
      this.$emit('playVoice');
    }
  }
}
</script>

<style scoped>
.img {
  display: block;
  width: 100%;
}
</style>
